import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portfolio")({
  // Legacy alias — permanently redirect to the canonical /projects.
  beforeLoad: () => {
    throw redirect({ to: "/projects", replace: true, statusCode: 301 });
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex" }],
    links: [
      { rel: "canonical", href: "https://precisionpaverspools.com/projects" },
    ],
  }),
});
